import React, { Component } from "react";
import { IconButton, TextField, Button,MenuItem } from "@material-ui/core";
import { Translation } from "react-i18next";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";
import { GoPlus } from "react-icons/go";
import clsx from "clsx";
import { __getMessageId, __getNotes, __getStatus } from "./utils";
// import trackFields from "../../_module/definition/trackFields";
import { PlaylistItemTypes } from "../../modules/ml-music-search/track/RecentPlaylistMenu";
import { canCreateClearanceForms, makeRandomId } from "../../util/CommonFunc";
import { CFOrgStatus } from "redux/Types";
import { v4 as uuidv4 } from "uuid";
class CreateAddClearance extends Component {
  canCreateCF = false;
  constructor(props) {
    super();
    this.state = {
      newCFMode: false,
      newCFName: "",
      focusList:false,
    };
    this.canCreateCF = canCreateClearanceForms();
  }

  onCreateClearanceConfirm = (e) => {
    const {
      user,
      items,
      tracks,
      setCFTracks,
      handleClose,
      showMessage,
      setRecentQuery,
      recentQuery,
      loadRecent,
      CreateAddClearance,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,

        }
      }
    } = this.props;
    handleClose(e);
    if (tracks?.length > 0 && this.state.newCFName.length > 0) {
      showMessage(`Adding track(s) to Clearance "${this.state.newCFName}"`);

      const trackIds = [];
      const cleanedTracks = [];
      const filteredTracks = items?.filter(
        (r) => !r.pl_prop_type || r.pl_prop_type === PlaylistItemTypes.track
      );
      if (filteredTracks) {
        filteredTracks.forEach((t) => {
          let sequenceId = uuidv4();
          if (tracks?.includes(t.id)) {
            trackIds.push(sequenceId);
          }
          const trackCopy = JSON.parse(JSON.stringify(t));
          trackCopy.pl_prop_id = undefined;
          trackCopy.pl_prop_type = undefined;
          trackCopy.pl_prop_position = undefined;
          trackCopy.pl_prop_notes = undefined;
          trackCopy.pl_prop_tags = undefined;
          trackCopy.highlights = undefined;
          trackCopy.skyMlId = t.id;
          trackCopy.id = sequenceId;
          cleanedTracks.push(trackCopy);
        });
      }

      let _date = new Date();
      
      let newform = {
        name: this.state.newCFName,
        genre: "1",
        notes: "",
        synopsis: "",
        // deadline: "",
        deadline: new Date().toISOString().split('T')[0],
        refNo: makeRandomId(),
        status: CFOrgStatus.INPROGRESS, 
        confirmed: [],
        clearance: {
          commits: null,
          props: [],
          tracks: trackIds,
        },
        tracksCount: trackIds.length,
      };

      cleanedTracks.map((v) => {
        let _tstatus = __getStatus(newform.clearance, v.id) || { v: 0 };
        let _tmessageid = __getMessageId(newform.clearance, v.id) || { v: null };

        let trackDetails = items.filter((d) => d.id == v.id)[0];
        if (trackDetails) {
          delete trackDetails['score'];
          delete trackDetails['scoreExp'];
          newform.confirmed.push({
            trackDetails: trackDetails,
            origin: trackDetails[trackFields.musicOrigin.id],
            clearancestatus:
              _tstatus.v && !_tstatus.unconfirmed ? _tstatus.v : 0,
            messageid: _tmessageid.v,
            by: _tstatus?.by || user.id,
            at: _tstatus?.at || new Date().toISOString(),
            adminOverridden: _tstatus?.adminOverridden || 0,
            trackNotes: (__getNotes(newform.clearance, v) || { v: [] }).v,
          });
        }
      });

      setCFTracks("saveform", null, { cf: newform, changedFields:[], changedTrackFields:['clearancestatus'], changedTrackIds:cleanedTracks.map(t=>t.id) }, (data, error) => {
        this.setState({
          newCFMode: false,
          newCFName: "",
        });
        if (error) {
          showMessage(error);
        } else {
          showMessage();
          setRecentQuery("");
          loadRecent({ ...recentQuery, q: "" });
        }
      });
    }
  };

  render() {
    const { classes, busy, tracks, } = this.props;

   const {focusList} = this.state;

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            {!this.state.newCFMode && (
              <MenuItem className={clsx(classes.createNewBox)} 
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.setState({ newCFMode: true });
              }} 
              autoFocus={focusList}
               disableRipple>
                <Button
                  className={classes.createNewClearance}
                  disabled={
                    !tracks || tracks?.length === 0 || busy || !this.canCreateCF
                      ? true
                      : false
                  }
                  onClickCapture={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.setState({ newCFMode: true });
                  }}
                >
                  <GoPlus className={classes.addPlaylistIcons} />
                  Create Clearance and Add
                </Button>
                </MenuItem>
              )}
            <div className={clsx(classes.createNewBox)}>
              {/* {!this.state.newCFMode && (
                <Button
                  className={classes.createNewClearance}
                  disabled={
                    !tracks || tracks?.length === 0 || busy || !canCreateCF()
                      ? true
                      : false
                  }
                  onClickCapture={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.setState({ newCFMode: true });
                  }}
                >
                  <GoPlus className={classes.addPlaylistIcons} />
                  Create Clearance and Add
                </Button>
              )} */}
              {this.state.newCFMode && (
                <>
                  <div className={classes.createNewWraper}>
                    <div
                      onClickCapture={(e) => {
                        // e.stopPropagation();
                        e.preventDefault();
                      }}
                      onKeyDown={(e) => {
                        e.stopPropagation();
                        // if (e.key === "Enter") {
                        //   if (this.state.newCFName) {
                        //     this.onCreateClearanceConfirm(e);
                        //   }
                        // }
                      }}
                    >
                      <TextField
                        autoComplete="off"
                        name="newClearanceFormName"
                        variant="outlined"
                        type="text"
                        autoFocus={true}
                        placeholder={"New Clearance form name"}
                        className={classes.recentPlaylistItemsSearch}
                        value={this.state.newCFName || ""}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                            if (this.state.newCFName) {
                                   this.onCreateClearanceConfirm(e);
                            }
                          }
                        }}
                        onChange={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.setState({
                            newCFName: e.currentTarget.value,
                          });
                        }}
                      />
                   
                    <div className={classes.createButtonsSet}>
                      <IconButton
                        color="primary"
                        className={classes.globalGreenButton}
                        aria-label="Create"
                        disabled={this.state.newCFName ? false : true}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          e.stopPropagation();
                          if (this.state.newCFName) {
                            this.onCreateClearanceConfirm(e);
                          }
                          }
                        }}
                        onClickCapture={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (this.state.newCFName) {
                            this.onCreateClearanceConfirm(e);
                          }
                        }}
                      >
                        <DoneIcon />
                      </IconButton>
                      <IconButton
                        color="primary"
                        className={classes.globalGrayButton}
                        aria-label="Close"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          e.stopPropagation();
                          this.setState({
                            newCFMode: false,
                            newCFName: "",
                            focusList:true,
                          });
                          }
                        }}
                        onClickCapture={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.setState({
                            newCFMode: false,
                            newCFName: "",
                            focusList:true,
                          });
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </Translation>
    );
  }
}

export default CreateAddClearance;
